import axios from '../external/Axios';
import Url from '../constants/Url';

class LegalApi {
    get(params) {
        return axios
            .get(Url().LEGAL.GET_GUARDIAN, {params})
            .then(res => {
                return res.data.data;
            })
            .catch(ex => {
                console.info('Failed to get:', ex.message, ex);
                throw ex;
            });
    }
    update(params) {
        return axios
            .post(Url().LEGAL.SAVE_GUARDIAN, params)
            .then(res => {
                return res.data.data;
            })
            .catch(ex => {
                console.info('Failed to update:', ex.message, ex);
                throw ex;
            });
    }
}

export default new LegalApi();
